import React, { Component } from "react";
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  FormGroup,
  Label,
  Input,
  Badge,
  Alert,
} from "reactstrap";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import { Colxx } from "../../../components/common/CustomBootstrap";
import {
  NotificatioErrController,
  NotificatioSucController,
  AddCommaNumber,
} from "../../../helpers/Utils";
import { Redirect } from "react-router-dom";
import ThumbListViewMenu from "./ThumbListViewMenu";

const PACKAGE_OPTIONS = [
  { value: "basic", label: "Basic" },
  { value: "pro", label: "Pro" },
  { value: "pro_auto", label: "Pro Auto" },
];

class Upgrade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: false,
      modal: false,
      valueModal: {
        id: 0,
        username: undefined,
        fullname: undefined,
        companyName: undefined,
        companyUUID: undefined,
      },
      valueModal: {
        id: 0,
        username: undefined,
        fullname: undefined,
        companyName: undefined,
        companyUUID: undefined,
      },
      // Admin Form State
      adminPackage: "enterprise",
      adminDuration: "1y",
      adminLimit: "",
      // Tab state
      activeTab: "1",
      // Promo state
      promoItems: [],
      promoLoading: true,
      promoModalOpen: false,
      promoEditItem: null,
      promoForm: {
        code: "",
        description: "",
        discount_type: "percent",
        discount_value: "",
        max_discount: "",
        applicable_packages: [],
        max_uses: "",
        start_date: "",
        end_date: "",
      },
      promoFormError: "",
      promoSubmitting: false,
      promoDeleteConfirm: null,
    };

    this.dataRender = this.dataRender.bind(this);
    this.handleActionSubmit = this.handleActionSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.dataRender();
  }

  dataRender() {
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .get(`${END_POINT + "/user-license/group"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState({
          data: data.data,
          isLoading: true,
        });
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText ||
          err.response?.data?.message ||
          err.message ||
          "Có lỗi xảy ra"
        );
      });
  }

  handleActionSubmit() {
    const { companyUUID } = this.state.valueModal;
    const { adminPackage, adminDuration, adminLimit } = this.state;

    let tokenStr = localStorage.getItem("access_token");

    // Check if we are doing a Standard "Approve Pending" or Admin "Force Update"
    // The previous logic only sent companyUUID to /upgrade.
    // We will now use /admin-update which is more powerful.

    axios
      .post(
        `${END_POINT + "/user-license/admin-update"}`,
        {
          companyUUID: companyUUID,
          target_package: adminPackage,
          duration: adminDuration,
          custom_api_limit: adminLimit,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        }
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController(data.responseText);

        this.dataRender();
        this.toggle();
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "Error");
      });
  }

  handleToggleModal = (e, f) => {
    this.setState({
      valueModal: {
        ...this.state.valueModal,
        id: f.user.id,
        username: f.user.username,
        fullname: f.user.fullname,
        companyName: f.user.companyName,
        companyUUID: f.user.companyUUID,
      },
    });

    this.toggle();
  };

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
      if (tab === "2" && this.state.promoLoading) {
        this.loadPromoData();
      }
    }
  };

  getHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  });

  loadPromoData = () => {
    axios
      .get(`${END_POINT}/user-license/promo-codes`, this.getHeaders())
      .then((res) => {
        this.setState({ promoItems: res.data.data || [], promoLoading: false });
      })
      .catch((err) => {
        this.setState({ promoLoading: false });
        if (err.response?.status === 403) {
          NotificatioErrController("Bạn không có quyền truy cập");
        }
      });
  };

  openPromoCreateModal = () => {
    this.setState({
      promoModalOpen: true,
      promoEditItem: null,
      promoFormError: "",
      promoForm: {
        code: "",
        description: "",
        discount_type: "percent",
        discount_value: "",
        max_discount: "",
        applicable_packages: [],
        max_uses: "",
        start_date: "",
        end_date: "",
      },
    });
  };

  openPromoEditModal = (item) => {
    this.setState({
      promoModalOpen: true,
      promoEditItem: item,
      promoFormError: "",
      promoForm: {
        code: item.code || "",
        description: item.description || "",
        discount_type: item.discount_type || "percent",
        discount_value: item.discount_value || "",
        max_discount: item.max_discount || "",
        applicable_packages: item.applicable_packages || [],
        max_uses: item.max_uses || "",
        start_date: item.start_date || "",
        end_date: item.end_date || "",
      },
    });
  };

  closePromoModal = () => {
    this.setState({ promoModalOpen: false, promoEditItem: null, promoFormError: "" });
  };

  onPromoFormChange = (field, value) => {
    this.setState((prev) => ({
      promoForm: { ...prev.promoForm, [field]: value },
    }));
  };

  onPromoPackageToggle = (pkg) => {
    this.setState((prev) => {
      const current = prev.promoForm.applicable_packages || [];
      const updated = current.includes(pkg)
        ? current.filter((p) => p !== pkg)
        : [...current, pkg];
      return { promoForm: { ...prev.promoForm, applicable_packages: updated } };
    });
  };

  handlePromoSubmit = () => {
    const { promoForm, promoEditItem } = this.state;
    if (!promoForm.code.trim() || !promoForm.discount_value) {
      return this.setState({
        promoFormError: "Vui lòng nhập mã và giá trị giảm giá",
      });
    }

    this.setState({ promoSubmitting: true, promoFormError: "" });

    const payload = {
      ...promoForm,
      code: promoForm.code.trim().toUpperCase(),
      discount_value: parseFloat(promoForm.discount_value),
      max_discount: promoForm.max_discount ? parseInt(promoForm.max_discount) : null,
      max_uses: promoForm.max_uses ? parseInt(promoForm.max_uses) : null,
      applicable_packages:
        promoForm.applicable_packages.length > 0
          ? promoForm.applicable_packages
          : null,
      start_date: promoForm.start_date || null,
      end_date: promoForm.end_date || null,
    };

    const request = promoEditItem
      ? axios.put(
          `${END_POINT}/user-license/promo-codes/${promoEditItem.id}`,
          payload,
          this.getHeaders(),
        )
      : axios.post(
          `${END_POINT}/user-license/promo-codes`,
          payload,
          this.getHeaders(),
        );

    request
      .then((res) => {
        NotificatioSucController(res.data.responseText || "Thành công");
        this.setState({ promoSubmitting: false, promoModalOpen: false });
        this.loadPromoData();
      })
      .catch((err) => {
        this.setState({
          promoSubmitting: false,
          promoFormError: err.response?.data?.responseText || "Có lỗi xảy ra",
        });
      });
  };

  handlePromoDelete = (id) => {
    axios
      .delete(
        `${END_POINT}/user-license/promo-codes/${id}`,
        this.getHeaders(),
      )
      .then(() => {
        NotificatioSucController("Xóa thành công");
        this.setState({ promoDeleteConfirm: null });
        this.loadPromoData();
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "Lỗi xóa");
      });
  };

  handlePromoToggleActive = (item) => {
    axios
      .put(
        `${END_POINT}/user-license/promo-codes/${item.id}`,
        { is_active: !item.is_active },
        this.getHeaders(),
      )
      .then(() => this.loadPromoData())
      .catch(() => NotificatioErrController("Lỗi cập nhật trạng thái"));
  };

  renderPromoTab() {
    const {
      promoItems,
      promoLoading,
      promoModalOpen,
      promoEditItem,
      promoForm,
      promoFormError,
      promoSubmitting,
      promoDeleteConfirm,
    } = this.state;

    return (
      <React.Fragment>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Quản lý mã khuyến mại</h4>
          <Button color="primary" size="sm" onClick={this.openPromoCreateModal}>
            <i className="simple-icon-plus mr-1" />
            Tạo mã KM
          </Button>
        </div>

        <Card>
          <CardBody className="p-0">
            {promoLoading ? (
              <div className="text-center p-5">
                <div className="loading" />
              </div>
            ) : promoItems.length === 0 ? (
              <div className="text-center p-5 text-muted">
                Chưa có mã khuyến mại nào
              </div>
            ) : (
              <Table responsive hover className="mb-0">
                <thead className="bg-light">
                  <tr>
                    <th>Mã</th>
                    <th>Mô tả</th>
                    <th>Giảm giá</th>
                    <th>Gói áp dụng</th>
                    <th>Sử dụng</th>
                    <th>Thời gian</th>
                    <th>Trạng thái</th>
                    <th style={{ width: 130 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {promoItems.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <strong>{item.code}</strong>
                      </td>
                      <td>{item.description || "-"}</td>
                      <td>
                        {item.discount_type === "percent"
                          ? `${item.discount_value}%`
                          : `${AddCommaNumber(item.discount_value)}đ`}
                        {item.max_discount && item.discount_type === "percent"
                          ? ` (max ${AddCommaNumber(item.max_discount)}đ)`
                          : ""}
                      </td>
                      <td>
                        {item.applicable_packages &&
                        item.applicable_packages.length > 0
                          ? item.applicable_packages
                              .map((p) => p.toUpperCase())
                              .join(", ")
                          : "All"}
                      </td>
                      <td>
                        {item.used_count} / {item.max_uses || "∞"}
                      </td>
                      <td>
                        {item.start_date || item.end_date
                          ? `${item.start_date || "..."} → ${item.end_date || "..."}`
                          : "-"}
                      </td>
                      <td>
                        <Badge
                          color={item.is_active ? "success" : "secondary"}
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handlePromoToggleActive(item)}
                        >
                          {item.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td>
                        <Button
                          color="link"
                          size="sm"
                          className="p-0 mr-3"
                          onClick={() => this.openPromoEditModal(item)}
                        >
                          <i className="simple-icon-pencil" />
                        </Button>
                        {promoDeleteConfirm === item.id ? (
                          <span>
                            <Button
                              color="link"
                              size="sm"
                              className="p-0 text-danger mr-1"
                              onClick={() => this.handlePromoDelete(item.id)}
                            >
                              OK
                            </Button>
                            <Button
                              color="link"
                              size="sm"
                              className="p-0"
                              onClick={() =>
                                this.setState({ promoDeleteConfirm: null })
                              }
                            >
                              <i className="simple-icon-close" />
                            </Button>
                          </span>
                        ) : (
                          <Button
                            color="link"
                            size="sm"
                            className="p-0 text-danger"
                            onClick={() =>
                              this.setState({ promoDeleteConfirm: item.id })
                            }
                          >
                            <i className="simple-icon-trash" />
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>

        {/* Create/Edit Promo Modal */}
        <Modal isOpen={promoModalOpen} toggle={this.closePromoModal} size="lg">
          <ModalHeader toggle={this.closePromoModal}>
            {promoEditItem ? "Sửa mã khuyến mại" : "Tạo mã khuyến mại"}
          </ModalHeader>
          <ModalBody>
            {promoFormError && <Alert color="danger">{promoFormError}</Alert>}

            <Row>
              <Colxx xxs="6">
                <FormGroup>
                  <Label>Mã khuyến mại *</Label>
                  <Input
                    value={promoForm.code}
                    onChange={(e) =>
                      this.onPromoFormChange("code", e.target.value.toUpperCase())
                    }
                    placeholder="VD: SALE50, NEWYEAR2026"
                  />
                </FormGroup>
              </Colxx>
              <Colxx xxs="6">
                <FormGroup>
                  <Label>Mô tả</Label>
                  <Input
                    value={promoForm.description}
                    onChange={(e) =>
                      this.onPromoFormChange("description", e.target.value)
                    }
                  />
                </FormGroup>
              </Colxx>
            </Row>

            <Row>
              <Colxx xxs="4">
                <FormGroup>
                  <Label>Loại giảm giá *</Label>
                  <Input
                    type="select"
                    value={promoForm.discount_type}
                    onChange={(e) =>
                      this.onPromoFormChange("discount_type", e.target.value)
                    }
                  >
                    <option value="percent">% Phần trăm</option>
                    <option value="fixed">Số tiền (đ)</option>
                  </Input>
                </FormGroup>
              </Colxx>
              <Colxx xxs="4">
                <FormGroup>
                  <Label>Giá trị giảm *</Label>
                  <Input
                    type="number"
                    value={promoForm.discount_value}
                    onChange={(e) =>
                      this.onPromoFormChange("discount_value", e.target.value)
                    }
                    placeholder={
                      promoForm.discount_type === "percent" ? "50" : "100000"
                    }
                  />
                </FormGroup>
              </Colxx>
              <Colxx xxs="4">
                <FormGroup>
                  <Label>Giảm tối đa</Label>
                  <Input
                    type="number"
                    value={promoForm.max_discount}
                    onChange={(e) =>
                      this.onPromoFormChange("max_discount", e.target.value)
                    }
                    disabled={promoForm.discount_type === "fixed"}
                  />
                </FormGroup>
              </Colxx>
            </Row>

            <FormGroup>
              <Label>Gói áp dụng</Label>
              <div className="d-flex">
                {PACKAGE_OPTIONS.map((pkg) => (
                  <Label key={pkg.value} check className="mr-4">
                    <Input
                      type="checkbox"
                      checked={(promoForm.applicable_packages || []).includes(
                        pkg.value,
                      )}
                      onChange={() => this.onPromoPackageToggle(pkg.value)}
                    />{" "}
                    {pkg.label}
                  </Label>
                ))}
              </div>
            </FormGroup>

            <Row>
              <Colxx xxs="4">
                <FormGroup>
                  <Label>Số lần dùng tối đa</Label>
                  <Input
                    type="number"
                    value={promoForm.max_uses}
                    onChange={(e) =>
                      this.onPromoFormChange("max_uses", e.target.value)
                    }
                  />
                </FormGroup>
              </Colxx>
              <Colxx xxs="4">
                <FormGroup>
                  <Label>Ngày bắt đầu</Label>
                  <Input
                    type="date"
                    value={promoForm.start_date}
                    onChange={(e) =>
                      this.onPromoFormChange("start_date", e.target.value)
                    }
                  />
                </FormGroup>
              </Colxx>
              <Colxx xxs="4">
                <FormGroup>
                  <Label>Ngày kết thúc</Label>
                  <Input
                    type="date"
                    value={promoForm.end_date}
                    onChange={(e) =>
                      this.onPromoFormChange("end_date", e.target.value)
                    }
                  />
                </FormGroup>
              </Colxx>
            </Row>

            <div className="text-right mt-3">
              <Button
                color="secondary"
                outline
                onClick={this.closePromoModal}
                className="mr-2"
              >
                Hủy
              </Button>
              <Button
                color="primary"
                onClick={this.handlePromoSubmit}
                disabled={promoSubmitting}
              >
                {promoSubmitting ? "..." : promoEditItem ? "Lưu" : "Tạo mã KM"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }

  render() {
    let { isLoading, data, modal, valueModal, activeTab } = this.state;

    const store = window.location.host.split(".")[0];
    // Allow access from 'admin' subdomain (unified dashboard) or 'upgrade' subdomain
    if (store !== "upgrade" && store !== "admin") {
      return <Redirect to="/app/dashboards/default" />;
    }

    return !isLoading ? (
      <div className="loading" />
    ) : (
      <Row>
        <Modal isOpen={modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{"Thông tin"}</ModalHeader>
          <ModalBody>
            <h3>Nâng cấp tài khoản</h3>
            <h6>Mã cửa hàng: {valueModal.companyUUID} </h6>
            <h6>Tên cửa hàng: {valueModal.companyName} </h6>
            <div className="text-center mb-3">
              <Button color="primary" onClick={this.handleActionSubmit}>
                {"Cập nhật / Nâng cấp"}
              </Button>{" "}
            </div>

            <hr />
            <h5>Cấu hình Admin</h5>
            <div className="form-group">
              <label>Gói cước</label>
              <select
                className="form-control"
                value={this.state.adminPackage}
                onChange={(e) =>
                  this.setState({ adminPackage: e.target.value })
                }
              >
                <option value="basic">Basic</option>
                <option value="pro">Pro</option>
                <option value="pro_auto">Pro Auto</option>
                <option value="enterprise">Enterprise</option>
              </select>
            </div>
            <div className="form-group">
              <label>Thời hạn</label>
              <select
                className="form-control"
                value={this.state.adminDuration}
                onChange={(e) =>
                  this.setState({ adminDuration: e.target.value })
                }
              >
                <option value="1m">1 Tháng</option>
                <option value="6m">6 Tháng</option>
                <option value="1y">1 Năm</option>
                <option value="2y">2 Năm</option>
                <option value="5y">5 Năm</option>
                <option value="forever">Trọn đời</option>
              </select>
            </div>
            <div className="form-group">
              <label>Custom API Limit (Để trống = Mặc định)</label>
              <input
                type="number"
                className="form-control"
                value={this.state.adminLimit}
                onChange={(e) => this.setState({ adminLimit: e.target.value })}
                placeholder="VD: 500000"
              />
            </div>
          </ModalBody>
        </Modal>
        <Colxx xxs="12" lg="12" md="12" className="d-block">
          <Nav tabs className="mb-4">
            <NavItem>
              <NavLink
                className={activeTab === "1" ? "active" : ""}
                onClick={() => this.toggleTab("1")}
                style={{ cursor: "pointer" }}
              >
                <i className="iconsminds-upgrade mr-1" />
                Quản lý nâng cấp
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "2" ? "active" : ""}
                onClick={() => this.toggleTab("2")}
                style={{ cursor: "pointer" }}
              >
                <i className="simple-icon-tag mr-1" />
                Quản lý mã KM
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <div className="mb-3 upgrade-page-heading__row">
                <div className="d-flex flex-grow-1 min-width-zero">
                  <div className="align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center card-body">
                    <p className="mb-0 text-muted w-20 w-xs-100 text-center">
                      <span>Họ và tên</span>
                    </p>
                    <p className="mb-0 text-muted w-20 w-xs-100 text-center">
                      <span>Tên cửa hàng</span>
                    </p>
                    <p className="mb-0 text-muted w-15 w-xs-100 text-center">
                      <span>Tên miền</span>
                    </p>
                    <p className="mb-0 text-muted w-20 w-xs-100 text-center">
                      <span>Mã CompanyUUID</span>
                    </p>
                    <p className="mb-0 text-muted w-20 w-xs-100 text-center">
                      <span>Ngày hết hạn</span>
                    </p>
                    <p className="mb-0 text-muted w-15 w-xs-100 text-center mr-card-body">
                      <span>Thời gian nâng cấp</span>
                    </p>
                  </div>
                </div>
              </div>

              <Card className="mb-4">
                <CardBody>
                  <CardTitle>{"YÊU CẦU NÂNG CẤP"}</CardTitle>
                  {data.dataPending.map((user, idx) => {
                    return (
                      <ThumbListViewMenu
                        key={idx}
                        item={user}
                        handleToggleModal={this.handleToggleModal}
                      />
                    );
                  })}
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <CardTitle>{"TÀI KHOẢN MIỄN PHÍ"}</CardTitle>
                  {data.dataTrial.map((user, idx) => {
                    return (
                      <ThumbListViewMenu
                        key={idx}
                        item={user}
                        handleToggleModal={this.handleToggleModal}
                      />
                    );
                  })}
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <CardTitle>{"ĐÃ HẾT HẠN"}</CardTitle>
                  {data.dataExpired &&
                    data.dataExpired.map((user, idx) => {
                      return (
                        <ThumbListViewMenu
                          key={idx}
                          item={user}
                          handleToggleModal={this.handleToggleModal}
                        />
                      );
                    })}
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <CardTitle>{"ĐÃ NÂNG CẤP"}</CardTitle>
                  {data.dataUpgraded.map((user, idx) => {
                    return (
                      <ThumbListViewMenu
                        key={idx}
                        item={user}
                        handleToggleModal={this.handleToggleModal}
                      />
                    );
                  })}
                </CardBody>
              </Card>
            </TabPane>

            <TabPane tabId="2">
              {this.renderPromoTab()}
            </TabPane>
          </TabContent>
        </Colxx>
      </Row>
    );
  }
}

export default Upgrade;
